import ClipboardJS from "clipboard";

const shareBtns = document.querySelectorAll("[data-clipboard-text]");
if (shareBtns) {
  shareBtns.forEach((btn) => {
    const button = new ClipboardJS(btn);

    button.on("success", function (e: any) {
      e.clearSelection();

      btn.textContent = "Link copied!";
      setTimeout(() => {
        btn.textContent = "Copy link to this story";
      }, 2000);
    });
  });
}
